import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Pagination } from '@mui/material';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css';
import { Config } from '../../../../../shared/config';
import PageToggleButton from '../../../../Common/PageToggleButton';
import etlService from '../../../ETL/etlService';

class EtlJobView extends Component {
    constructor(props) {
        super(props);
        const session = localStorage.getItem('FOM_user');
        this.state = {
            dataSourceId: null,
            etlJobInfo: {},
            errorData: [],
            noRecordsMessage: null,
            showPagination: false,
            lastRefreshTime: null,
            noRecordsFound: true,
            userdata: session ? JSON.parse(session).userdata.details : null,
            pagination: {
                total: 0,
                lastPage: 0,
                prevPage: null,
                nextPage: null,
                perPage: 0,
                currentPage: 1,
                from: 0,
                to: 0},
            rowsPerPage: 50,
            page: 1,
            totalCount: 0
        };
        this.etlService = new etlService();
        this.downloadErrorDataFile = this.downloadErrorDataFile.bind(this);
    }


    /**
     * Ui elements rendering
     */
    render() {
        const { errorData, noRecordsMessage, noRecordsFound, showPagination, userdata, dataSourceId ,totalCount, page, rowsPerPage} = this.state;
        const isUserAdmin = userdata?.role === Config.user.role.admin;

        return (
            <>
                <Row className="mt-4 file-padding">
                    <Col md={6}>
                        <h5 className="mb-0 mt-3 ml-2">File Processing Error Detail:</h5>
                    </Col>
                    <Col md={6}>
                        <div className="pull-right float-right mr-3 mt-1 mb-1">
                            {/* Download Error button is enabled just for Admin users */}
                            {isUserAdmin && (
                                <Button
                                    variant="outline-secondary"
                                    sm="1"
                                    size="sm"
                                    onClick={this.downloadErrorDataFile}
                                    disabled={!dataSourceId || noRecordsFound}
                                >
                                    <FontAwesomeIcon className="btn-icon" icon={faDownload} />
                                    <span className="ml-2">Download Error Data File</span>
                                </Button>
                            )}
                        </div>
                    </Col>
                </Row>
                <div className="table-responsive-cm">
                    <ReactTable
                        columns={[
                            {
                                Header: 'Line Number',
                                accessor: 'lineNumber',
                                width: 100,
                            },
                            {
                                Header: 'Error Type',
                                accessor: 'dataSourceSchema',
                                width: 150,
                            },
                            {
                                Header: 'Error Message',
                                accessor: 'errorMessage',
                            },
                            {
                                Header: 'Error Reason',
                                accessor: 'errorReason',
                            },
                            {
                                Header: 'Notes',
                                accessor: 'notes',
                                width: 300,
                            },
                        ]}
                        data={errorData}
                        noDataText={noRecordsMessage}
                        minRows={errorData.length}
                        showPagination={showPagination}
                        pageSize={errorData.length}
                        className="-highlight cursor-pointer w-100"
                        style={
                            errorData.length >= 5
                                ? {
                                      height: 'calc(100vh - 400px)',
                                  }
                                : {}
                        }
                    />
                </div>
                <div className='pagination-div'>

                <Pagination  showFirstButton showLastButton
                    component="div"
                    count={totalCount}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onChange={this.handleChangePage}
                    variant="outlined"
                    shape="rounded"
                    sx={{
                        ".MuiPaginationItem-root": {
                            marginTop: '15px',
                            fontSize: '16px'
                          },
                          ".Mui-selected": {
                            backgroundColor: '#135d87 !important',
                            color:'#fff',
                           }
                      }}
                />
                <PageToggleButton rowsPerPageOptions={[10, 25, 50, 500]} 
                                perPageCount= {rowsPerPage}  
                                rowsPerPage={(perPage) => {this.setState({rowsPerPage: perPage}); this.onPageOrPageLoadChange(1, perPage)}}/>
                </div>
               
            </>
        );
    }

    /**
     * Component updated
     */
    componentDidUpdate(prevProps) {
        if (prevProps.dataSourceId !== this.props.dataSourceId) {
            this.refreshErrorList(this.props.dataSourceId);
        }
    }

   async onPageOrPageLoadChange(page, perPage){
        this.setState({page: page});
        if(this.state.dataSourceId){
            await this.etlService.getEtlJobErrorData(this.props.dataSourceId, perPage, page, this.props.customerId, this.props.mode).then((res) => {
                if (res && res.status === 'Success') {
                    this.setState({
                        errorData: res.data.data,
                        noRecordsMessage: res.data.data && res.data.data.length > 0 ? null : 'No Errors Found',
                        lastRefreshTime: moment().format(Config.UI_TIMESTAMP_FORMAT),
                        noRecordsFound: res.data.data.length > 0 ? false : true,
                        totalCount: res.data.pagination.lastPage,
                        page: res.data.pagination.currentPage,
                    });
                } else {
                    this.setState({
                        etlJobData: [],
                        noRecordsMessage: '-Failed Getting Errors-',
                    });
                }
            });
        }
    }

    refreshErrorList(dataSourceId) {
       // const limit = Number(process.env.REACT_APP_ERROR_REPORT_LIMIT || '1000');
        const { page, rowsPerPage} = this.state;
        this.etlService.getEtlJobErrorData(dataSourceId, rowsPerPage, page, this.props.customerId, this.props.mode).then((res) => {
            if (res && res.status === 'Success') {
                this.setState({
                    dataSourceId: dataSourceId,
                    errorData: res.data.data,
                    noRecordsMessage: res.data.data && res.data.data.length > 0 ? null : 'No Errors Found',
                    lastRefreshTime: moment().format(Config.UI_TIMESTAMP_FORMAT),
                    noRecordsFound: res.data.data.length > 0 ? false : true,
                    pagination: res.data.pagination,
                    page: 1,
                    totalCount: res.data.pagination.lastPage
                });
            } else {
                this.setState({
                    dataSourceId: dataSourceId,
                    etlJobData: [],
                    noRecordsMessage: '-Failed Getting Errors-',
                    page: 1,
                });
            }
        });
    }
    
    downloadErrorDataFile() {
        const { dataSourceId } = this.state;
        this.etlService.getEtlJobErrorDataFileDownloadUrl(dataSourceId, this.props.customerId, this.props.mode);
    }

     handleChangePage = async (event, newPage) => {
        this.setState({page: newPage});
        await  this.etlService.getEtlJobErrorData(this.props.dataSourceId, this.state.rowsPerPage, newPage, this.props.customerId, this.props.mode).then((res) => {
            if (res && res.status === 'Success') {
                this.setState({
                    errorData: res.data.data,
                    noRecordsMessage: res.data.data && res.data.data.length > 0 ? null : 'No Errors Found',
                    lastRefreshTime: moment().format(Config.UI_TIMESTAMP_FORMAT),
                    noRecordsFound: res.data.data.length > 0 ? false : true
                });
            } else {
                this.setState({
                    etlJobData: [],
                    noRecordsMessage: '-Failed Getting Errors-',
                });
            }
        });

    };
    
    handleChangeRowsPerPage = (event) => {
        this.setState({rowsPerPage: parseInt(event.target.value, 10), page: 0});
    };
}

EtlJobView.propTypes = {
    dataSourceId: PropTypes.number,
    customerId: PropTypes.number,
    mode: PropTypes.string,
};

export default EtlJobView;